module.exports = __webpack_public_path__ + "card.png?c10622bcedd9d66ff2e17665f5cfbb6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card.png
// module id = 169
// module chunks = 0